"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialPaymentSchema = void 0;
exports.partialPaymentSchema = {
    type: 'object',
    required: [],
    properties: {
        amount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with maximum length of 100 characters or null',
        },
        comment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should be a string with maximum length of 1000 characters or null',
        },
        datePaid: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with maximum length of 100 characters or null',
        },
    },
};
